import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {categoryPermissionChecker, PermissionName, PermissionMatrixName} from '@netx/core-permissions-next';
import {type ICategory} from '../schema';

export const canImportToCategory = (category?: ICategory): boolean => {
	if (category == null) return false;
	if (category.categoryid === 1) return false;
	if (isBrandPortal()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.IMPORTER)) return false;

	return categoryPermissionChecker({
		category,
		permissionMatrixName: PermissionMatrixName.ADD,
		permissionName: PermissionName.UPLOAD,
	});
};
